<template>
  <v-row>
    <v-col cols="12">
      <div
        class="box-bg font-16 font-w-500 d-flex justify-space-between align-center"
      >
        <section class="d-flex align-center gap-8">
          <div class="box-logo--red">
            <i class="icon-M02 text-red font-20"></i>
          </div>
          <span>ยอดซื้อสะสมเดือนปัจจุบัน </span>
          <span class="font-13">({{ bpDetail.date_month }}) :</span>
        </section>
        <section>
          <span>{{ numberFormat(bpDetail.sum_netamount_currentmonth) }} ฿</span>
        </section>
      </div>
    </v-col>
    <v-col cols="7">
      <div class="box-bg d-flex">
        <div style="flex: 1; border-right: 1px solid #bbbdbf">
          <section class="font-16 font-grey font-w-500">
            <span>ยอดซื้อสะสมปีปัจจุบัน :</span>
            <br />
            <span class="font-13">({{ bpDetail.date_ty }})</span>
          </section>
          <section class="font-16 font-w-500">
            <span>{{ numberFormat(bpDetail.sum_amount_ty) }} ฿</span>
          </section>
        </div>
        <div style="flex: 1; margin-left: 24px">
          <section class="font-16 font-grey font-w-500">
            <span>ยอดซื้อสะสมปีก่อนหน้า :</span>
            <br />
            <span class="font-13">({{ bpDetail.date_ly }})</span>
          </section>
          <section class="font-16 font-w-500">
            <span>{{ numberFormat(bpDetail.sum_amount_ly) }} ฿</span>
          </section>
        </div>
      </div>
    </v-col>
    <v-col cols="5">
      <div class="box-bg d-flex gap-12">
        <div class="box-logo--blue">
          <img src="/img/icons/icon-chart-bar.svg" alt="" />
        </div>
        <div>
          <span class="font-16 font-w-500 font-grey">อัตราการเติบโต :</span>
          <div class="d-flex align-center gap-12">
            <span class="font-16 font-w-600">
              <span v-if="bpDetail.diff_yoy > 0" class="text-green">
                +{{ numberFormat(bpDetail.diff_yoy) }} ฿
              </span>
              <span v-else-if="bpDetail.diff_yoy < 0" class="text-red">
                {{ numberFormat(bpDetail.diff_yoy) }} ฿
              </span>
              <span v-else>0 ฿</span>
            </span>

            <div v-if="bpDetail.gr_yoy > 0" class="badge--green">
              <span class="font-12 font-white font-w-500">
                +{{ numberFormat(bpDetail.gr_yoy) }}%
              </span>
              <v-icon size="14" color="#fff">mdi-arrow-up-thin</v-icon>
            </div>
            <div v-if="bpDetail.gr_yoy < 0" class="badge--red">
              <span class="font-12 font-white font-w-500">
                {{ numberFormat(bpDetail.gr_yoy) }}%
              </span>
              <v-icon size="14" color="#fff">mdi-arrow-down-thin</v-icon>
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import numeral from 'numeral'

export default {
  props: {
    bpDetail: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    numberFormat(value) {
      if (Number(value) === 0) {
        return '0'
      }
      return numeral(value).format('0,0')
    },
  },
}
</script>

<style lang="scss" scoped>
.box-bg {
  border-radius: 8px;
  background: #f5f5f5;
  padding: 16px;
  height: 100%;
}

.box-logo {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  &--red {
    @extend .box-logo;
    background: #f6e7e9;
  }
  &--blue {
    @extend .box-logo;
    background: #e0e8f1;
  }
}

.badge {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4;
  padding: 2px 6px;
  &--green {
    @extend .badge;
    border-radius: 35px;
    background: #1c9d07;
  }
  &--red {
    @extend .badge;
    border-radius: 35px;
    background: #a9182a;
  }
}
</style>
